// Newsletter form enhancements: client-side validation with native form submission and discount redirect.

(function () {
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FORM_SELECTOR = '[data-newsletter-form]';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function focusElement(el) {
    if (!el) return;
    requestAnimationFrame(function () {
      if (typeof el.focus === 'function') {
        el.focus();
      }
    });
  }

  function initNewsletterForm(form) {
    if (!form || form.dataset.newsletterInitialized === 'true') {
      return;
    }
    form.dataset.newsletterInitialized = 'true';

    var emailInput = form.querySelector('[data-newsletter-input]');
    var submitButton = form.querySelector('[data-newsletter-submit]');
    var clientError = form.querySelector('[data-newsletter-client-error]');
    var serverError = form.querySelector('[data-newsletter-server-error]');
    var modalElement = form.closest('newsletter-modal');
    var discountUrl = null;
    var isSubmitting = false;

    // Build discount URL from modal data attributes
    if (modalElement) {
      var discountCode = modalElement.dataset.discountCode;
      var discountRedirect = modalElement.dataset.discountRedirect || '/';
      if (discountCode) {
        discountUrl = '/discount/' + discountCode + '?redirect=' + encodeURIComponent(discountRedirect);
      }
    }

    function showClientError(message) {
      if (!clientError) return;
      clientError.textContent = message;
      clientError.hidden = false;
      clientError.classList.add('is-active');
      emailInput && emailInput.setAttribute('aria-invalid', 'true');
    }

    function clearClientError() {
      if (!clientError) return;
      clientError.textContent = '';
      clientError.hidden = true;
      clientError.classList.remove('is-active');
      emailInput && emailInput.removeAttribute('aria-invalid');
    }

    function clearServerError() {
      if (!serverError) return;
      serverError.hidden = true;
      serverError.classList.add('is-dismissed');
    }

    function setInputErrorState(hasError) {
      if (!emailInput) return;
      if (hasError) {
        emailInput.classList.add('error');
      } else {
        emailInput.classList.remove('error');
      }
    }

    function validateEmail() {
      if (!emailInput) return false;

      var email = emailInput.value.trim();
      clearClientError();
      clearServerError();
      emailInput.setCustomValidity('');

      if (!email || !EMAIL_REGEX.test(email)) {
        var message = form.getAttribute('data-error-copy') || 'Please enter a valid email address';
        showClientError(message);
        emailInput.setCustomValidity(message);
        setInputErrorState(true);
        return false;
      }

      setInputErrorState(false);
      return true;
    }

    function setSubmitButtonBusy() {
      if (!submitButton) return;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('is-loading');
      submitButton.disabled = true;
      var loadingLabel = submitButton.getAttribute('data-loading-label');
      if (loadingLabel) {
        submitButton.textContent = loadingLabel;
      }
    }

    function handleFormSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (isSubmitting) {
        return false;
      }

      if (!validateEmail()) {
        focusElement(emailInput);
        return false;
      }

      // Store discount URL in sessionStorage for post-redirect
      if (discountUrl && modalElement) {
        sessionStorage.setItem('newsletter_discount_redirect', discountUrl);
      }

      // Update button state
      setSubmitButtonBusy();
      isSubmitting = true;

      // Let Shopify handle the form naturally - no AJAX to avoid rate limits
      form.removeEventListener('submit', handleFormSubmit);
      form.submit();

      return false;
    }

    function onInputChange() {
      if (validateEmail()) {
        clearClientError();
        setInputErrorState(false);
      }
    }

    // Attach event listeners
    if (emailInput) {
      emailInput.addEventListener('input', onInputChange);
      emailInput.addEventListener('blur', onInputChange);
    }

    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }
  }

  ready(function () {
    // Check if we just completed a newsletter signup and should redirect to discount
    var discountRedirect = sessionStorage.getItem('newsletter_discount_redirect');
    if (discountRedirect && window.location.search.includes('customer_posted=true')) {
      sessionStorage.removeItem('newsletter_discount_redirect');
      window.location.href = discountRedirect;
      return;
    }

    document.querySelectorAll(FORM_SELECTOR).forEach(initNewsletterForm);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(FORM_SELECTOR)) {
            initNewsletterForm(node);
          } else {
            node.querySelectorAll && node.querySelectorAll(FORM_SELECTOR).forEach(initNewsletterForm);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();